<div class="helper-dialog-container">
  <div class="dialog-icon">?</div>

  @if (helpResult) {
    <div class="dialog-content">
      <div class="dialog-header">
        <div class="title">
          {{helpResult.label}}
        </div>
      </div>
      <div class="dialog-body hub-custom-scrollbar">
        @if (helpResult.contentHtmlShort) {
          <div>
            <div [innerHTML]="helpResult.contentHtmlShort"></div>
            @if (helpResult.link && helpResult.link.length) {
              <div class="content-link"><a target="_blank"
              href="{{helpResult.link}}">Read more</a></div>
            }
          </div>
        }
      </div>
      <div class="dialog-footer">
        @if (helpResult.contentHtmlShort) {
          <button (click)="closeDialog()" type="button"
          class="btn btn-primary">Ok</button>
        } @else {
          <button type="button" class="btn btn-primary" disabled>
            <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
            Loading...
          </button>
        }
      </div>
    </div>
  }
</div>
